import MapTableSelector from "@commons/Table/TableHeader/MapTableSelector";
import { usePage } from "@hooks/usePage";
import DevicesFilter from "../components/DevicesFilter";
import { useState } from "react";
import { Tab, Tabs } from "@mui/material";
import TableCameraTrap from "../components/cameraTrap/TableCameraTrap";
import TableCollar from "../components/collar/TableCollar";
import MapCollar from "../components/collar/MapCollar";
import MapCameraTrap from "../components/cameraTrap/MapCameraTrap";
import ModalNewCollar from "../components/collar/ModalNewCollar";
import ModalNewCameraTrap from "../components/cameraTrap/ModalNewCameraTrap";
import ModalEditCollar from "../components/collar/ModalEditCollar";
import ModalEditCameraTrap from "../components/cameraTrap/ModalEditCameraTrap";

type DeviceType = "collar" | "cameraTrap";

function DevicesScreen() {
  const { viewMode } = usePage();
  const [selectedDevice, setSelectedDevice] = useState<DeviceType>("collar");
  const [filterValue, setFilterValue] = useState("");
  const [appliedFilters, setAppliedFilters] = useState("");

  const handleFilterChange = (_field: string, value: string) => {
    setFilterValue(value);
  };

  const handleApplyFilters = () => {
    setAppliedFilters(filterValue);
  };

  const renderContent = () => {
    const components = {
      map: {
        collar: <MapCollar filters={appliedFilters} />,
        cameraTrap: <MapCameraTrap filters={appliedFilters} />,
      },
      table: {
        collar: <TableCollar filter={appliedFilters} />,
        cameraTrap: <TableCameraTrap filter={appliedFilters} />,
      },
    };

    return components[viewMode][selectedDevice];
  };

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap justify-center md:justify-between items-start gap-6">
        <MapTableSelector />
      </div>

      <DevicesFilter
        filterValue={filterValue}
        onChange={handleFilterChange}
        onApply={handleApplyFilters}
      />

      <div>
        <Tabs
          value={selectedDevice}
          onChange={(_, newValue) => setSelectedDevice(newValue)}
          textColor="primary"
          indicatorColor="primary"
          aria-label="tabs de dispositivos"
          className="ml-4 mt-2"
        >
          <Tab value="collar" label="Rastreador" />
          <Tab value="cameraTrap" label="Câmera Trap" />
        </Tabs>

        {renderContent()}
      </div>

      <ModalNewCollar />
      <ModalNewCameraTrap />
      <ModalEditCollar />
      <ModalEditCameraTrap />
    </div>
  );
}

export default DevicesScreen;
